import React from "react";
import moment from "moment-timezone";

import { useOHData } from "../../redux/hooks/openHousesHooks";
import { useUIBehavior } from "../../redux/hooks/uiHooks";
import * as S from "./styled";

const CallModalCard = () => {
  const {
    count,
    nearestDate,
    recentNumberOpenHouses,
    type,
    upcomingNumberOpenHouses
  } = useOHData();
  const { openModal, sendViewOHonMyActivity } = useUIBehavior();
  const isUpcoming = type === "active";
  const pluralEnd = count > 1 ? "s" : "";

  return (
    <S.Wrapper>
      <S.CalendarIcon />
      <S.InfoBox>
        <S.Title>
          {count} {isUpcoming ? "upcoming" : "past"} open house{pluralEnd}
        </S.Title>
        <S.OHTime>
          {isUpcoming ? "Next" : "Past"}:{" "}
          {moment(nearestDate)
            .tz("America/New_York")
            .format("ddd, MMM DD")}
        </S.OHTime>
        <S.CallModalButton
          onClick={() => {
            sendViewOHonMyActivity(
              recentNumberOpenHouses,
              upcomingNumberOpenHouses
            );
            openModal();
          }}
        >
          View open house{pluralEnd}
        </S.CallModalButton>
        <S.CallModalButtonMWeb
          onClick={() => {
            sendViewOHonMyActivity(
              recentNumberOpenHouses,
              upcomingNumberOpenHouses
            );
            openModal();
          }}
        >
          <S.ArrowIcon />
        </S.CallModalButtonMWeb>
      </S.InfoBox>
    </S.Wrapper>
  );
};

export default CallModalCard;
